import { Injectable, Inject, PLATFORM_ID, Component, Input, ViewChild, EventEmitter, Directive, ElementRef, Renderer2, HostListener, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { BehaviorSubject, Subject, fromEvent, timer } from 'rxjs';
import { takeUntil, debounceTime, map, skip } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/Authority.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Authority {
    // 公開發表日期
    constructor() {
        this.type = null;
        this.type1Select1 = null;
        this.type1Select2 = null;
    }
}
if (false) {
    /** @type {?} */
    Authority.prototype.id;
    /** @type {?} */
    Authority.prototype.mode;
    /** @type {?} */
    Authority.prototype.type;
    /** @type {?} */
    Authority.prototype.type1Select1;
    /** @type {?} */
    Authority.prototype.type1Input1;
    /** @type {?} */
    Authority.prototype.type1Select2;
    /** @type {?} */
    Authority.prototype.type1Date;
}
/** @type {?} */
const TYPE1_OPTIONS = [
    { label: '公眾領域標章(PDM)', value: 0, url: 'http://creativecommons.tw/pdm', image: './assets/image/publicdomain.large.png' },
    { label: '公眾領域貢獻宣告(CC0)', value: 1, url: 'http://creativecommons.tw/cc0', image: './assets/image/CCzero.large.png' },
    { label: '政府資料開放授權條款-第1版(OGDL 1.0)', value: 2, url: 'https://data.gov.tw/license', image: '' },
    { label: '創用CC姓名標示 3.0 台灣及其後版本(CC BY 3.0 TW +)', value: 3, url: 'https://creativecommons.org/licenses/by/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by/3.0/tw/88x31.png' },
    { label: '創用CC姓名標示-相同方式分享 3.0 台灣及其後版本(CC BY-SA 3.0 TW +)', value: 4, url: 'https://creativecommons.org/licenses/by-sa/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-sa/3.0/tw/88x31.png' },
    { label: '創用CC姓名標示-非商業性 3.0 台灣及其後版本(CC BY-NC 3.0 TW +)', value: 5, url: 'https://creativecommons.org/licenses/by-nc/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc/3.0/tw/88x31.png' },
    { label: '創用CC姓名標示-非商業性-相同方式分享 3.0 台灣及其後版本(CC BY-NC-SA 3.0 TW +)', value: 6, url: 'https://creativecommons.org/licenses/by-nc-sa/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc-sa/3.0/tw/88x31.png' },
    { label: '創用CC姓名標示-禁止改作 3.0 台灣及其後版本(CC BY-ND 3.0 TW +)', value: 7, url: 'https://creativecommons.org/licenses/by-nd/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nd/3.0/tw/88x31.png' },
    { label: '創用CC姓名標示-非商業性-禁止改作 3.0 台灣及其後版本(CC BY-NC-ND 3.0 TW +)', value: 8, url: 'https://creativecommons.org/licenses/by-nc-nd/3.0/tw/legalcode', image: 'https://i.creativecommons.org/l/by-nc-nd/3.0/tw/88x31.png' },
    { label: '台中自由文化授權條款 1.0(相容於CC BY 4.0)', value: 9, url: 'http://digitalculture.tw/license/TCFCL', image: '' },
    { label: '台中開放文化授權條款 1.0(相容於CC BY-SA 4.0)', value: 10, url: 'http://digitalculture.tw/license/TCOCL', image: '' },
    { label: '受著作權法保護-僅限於本平台有限度公開瀏覽', value: 11, url: '', image: '' },
    { label: '資料尚待處理，僅做暫存', value: 12, url: '', image: '' }
];
/** @type {?} */
const TYPE2_OPTIONS1 = [
    { label: '自然人著作', value: 0 },
    { label: '法人著作', value: 1 }
];
/** @type {?} */
const TYPE2_OPTIONS2 = [
    { label: '長期著作保護類型', value: 0 },
    { label: '短期著作保護類型', value: 1 }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} renderer
 * @param {?} parentEl
 * @param {?} styleName
 * @param {?} path
 * @param {?=} preload
 * @return {?}
 */
function loadLazyCssFile(renderer, parentEl, styleName, path, preload) {
    if (document.getElementById(styleName)) {
        return;
    }
    /** @type {?} */
    const style = renderer.createElement('link');
    renderer.setAttribute(style, 'id', `${styleName}`);
    renderer.setAttribute(style, 'href', `${path}`);
    renderer.setAttribute(style, 'onload', `this.rel='stylesheet'`);
    if (preload) {
        renderer.setAttribute(style, 'rel', `preload`);
        renderer.setAttribute(style, 'as', `style`);
        renderer.insertBefore(parentEl.closest('body'), style, parentEl.closest('body').firstElementChild);
    }
    else {
        renderer.setAttribute(style, 'rel', `stylesheet`);
        renderer.insertBefore(document.body, style, document.body.firstElementChild);
    }
}
/**
 * @param {?} renderer
 * @param {?} scriptName
 * @return {?}
 */
function loadLazyJsFile(renderer, scriptName) {
    if (window.document.getElementById(scriptName)) {
        return;
    }
    /** @type {?} */
    const script = renderer.createElement('script');
    renderer.setAttribute(script, 'id', `${scriptName}`);
    renderer.setAttribute(script, 'type', `text/javascript`);
    renderer.setAttribute(script, 'src', `${scriptName}`);
    renderer.setAttribute(script, 'async', ``);
    renderer.appendChild(document.body, script);
}
/**
 * @return {?}
 */
function checkIsTouchMobile() {
    /** @type {?} */
    let hasTouchScreen = false;
    /** @type {?} */
    const navigator = window.navigator;
    if ('maxTouchPoints' in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    }
    else if ('msMaxTouchPoints' in navigator) {
        hasTouchScreen = ((/** @type {?} */ (navigator))).msMaxTouchPoints > 0;
    }
    else {
        /** @type {?} */
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
            hasTouchScreen = !!mQ.matches;
        }
        else if ('orientation' in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        }
        else {
            // Only as a last resort, fall back to user agent sniffing
            /** @type {?} */
            const UA = ((/** @type {?} */ (navigator))).userAgent;
            hasTouchScreen = (/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA));
        }
    }
    return hasTouchScreen;
}
/**
 * @return {?}
 */
function closestPolifill() {
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            ((/** @type {?} */ (Element.prototype))).msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = (/**
         * @param {?} s
         * @return {?}
         */
        function (s) {
            /** @type {?} */
            let el = this;
            do {
                if (typeof s === 'string' && Element.prototype.matches.call(el, s)) {
                    return el;
                }
                else if (typeof s === 'object' && el === s) {
                    return el;
                }
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        });
    }
}
/**
 * @param {?} target
 * @param {?} findEl
 * @return {?}
 */
function find(target, findEl) {
    if (target === null || target.nodeType !== 1) {
        return null;
    }
    if (target === findEl) {
        return target;
    }
    /** @type {?} */
    let childs = target.children;
    for (let i = 0, el = childs[i]; i < childs.length; el = childs[++i]) {
        /** @type {?} */
        const f = find((/** @type {?} */ (el)), findEl);
        if (f) {
            return f;
        }
    }
    return null;
}
/**
 * 對 val 四捨五入取小數點後第 precision 位
 * @param {?} val
 * @param {?} precision
 * @return {?}
 */
function roundDecimal(val, precision) {
    return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}
/**
 * 取得元素 px 單位寬度，(解決原本是相對單位尺寸)
 * copy from [here](https://stackoverflow.com/questions/28606058/what-is-the-equivalent-of-height-and-width-of-jquery-in-pure-javascript)
 * @param {?} element
 * @param {?} value
 * @return {?}
 */
function getPixelValue(element, value) {
    if (/^\d+(px)?$/i.test(value)) {
        return parseInt(value, 10);
    }
    /** @type {?} */
    const style = element.style.left;
    /** @type {?} */
    const runtimeStyle = element.runtimeStyle.left;
    element.runtimeStyle.left = element.currentStyle.left;
    element.style.left = value || 0;
    value = element.style.pixelLeft;
    element.style.left = style;
    element.runtimeStyle.left = runtimeStyle;
    return value;
}
/**
 * 取得元素的大小(by px)
 * @param {?} el HTML元素
 * @return {?}
 */
function getElementStyleSize(el) {
    if (window.getComputedStyle) {
        /** @type {?} */
        const computedStyle = getComputedStyle(el, null);
        /** @type {?} */
        const w = computedStyle.width;
        /** @type {?} */
        const h = computedStyle.height;
        return {
            w: w === 'auto' ? 0 : roundDecimal(parseFloat(w), 5),
            h: h === 'auto' ? 0 : roundDecimal(parseFloat(h), 5),
        };
    }
    else {
        return {
            w: roundDecimal(parseFloat(getPixelValue(el, ((/** @type {?} */ (el))).currentStyle.width)), 5),
            h: roundDecimal(parseFloat(getPixelValue(el, ((/** @type {?} */ (el))).currentStyle.height)), 5),
        };
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/photo-swipe.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 可手勢滑動的相簿瀏覽器服務
 */
class PhotoSwipeService {
    /**
     * @param {?} platformId
     */
    constructor(platformId) {
        this.platformId = platformId;
        /**
         * 圖片資料
         */
        this.data$ = new BehaviorSubject([]);
        /**
         * 相簿瀏覽器是否開啟中
         */
        this.isOpened$ = new BehaviorSubject(false);
        /**
         * 當前瀏覽Slide的指標改變
         */
        this.indexChanged$ = new Subject();
        /**
         * 圖片下載資料
         */
        this.downloadData$ = new BehaviorSubject(undefined);
        this.isTouchDevice = false;
        /**
         * 查看當前焦點是否在相簿瀏覽器內，若不在就關閉相簿瀏覽器
         */
        this.handleFocusInEventHandler = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (this.isOpened) {
                /** @type {?} */
                const tg = (/** @type {?} */ (event.target));
                /** @type {?} */
                const pswp = document.querySelector('.pswp');
                if (pswp !== tg) {
                    /** @type {?} */
                    const find = tg.closest('.pswp');
                    if (!find) {
                        this.close();
                    }
                }
            }
        });
        if (isPlatformBrowser(this.platformId)) {
            this.changes = new MutationObserver((/**
             * @param {?} mutations
             * @return {?}
             */
            (mutations) => {
                this.cancelObserveDomChange();
                this.checkIsImgLoaded();
            }));
        }
        this.isTouchDevice = checkIsTouchMobile();
    }
    /**
     * @return {?}
     */
    get data() { return this.data$.value; }
    /**
     * @param {?} d
     * @return {?}
     */
    set data(d) { this.data$.next(d); }
    /**
     * 相簿瀏覽器是否開啟中
     * @return {?}
     */
    get isOpened() { return this.isOpened$.value; }
    /**
     * 相簿瀏覽器是否開啟中
     * @param {?} open
     * @return {?}
     */
    set isOpened(open) { this.isOpened$.next(open); }
    /**
     * 當前瀏覽Slide的指標
     * @return {?}
     */
    get currentIndex() { return this.photoSwiper && this.photoSwiper.getCurrentIndex(); }
    /**
     * 當前瀏覽Slide
     * @return {?}
     */
    get currentItem() { return (/** @type {?} */ (this.data[this.currentIndex])); }
    /**
     * 圖片下載資料
     * @return {?}
     */
    get downloadData() { return this.downloadData$.value; }
    /**
     * 圖片下載資料
     * @param {?} d
     * @return {?}
     */
    set downloadData(d) { this.downloadData$.next(d); }
    /**
     * @return {?}
     */
    get isCurrentHtmlSlide() {
        if (((/** @type {?} */ (this.data[this.currentIndex]))).src) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * @return {?}
     */
    get isCurrentFigureSlide() {
        return !this.isCurrentHtmlSlide;
    }
    /**
     * @return {?}
     */
    get canDownload() {
        /** @type {?} */
        const slide = (/** @type {?} */ (this.currentItem));
        return this.isCurrentFigureSlide && slide.imageAuthority && slide.imageAuthority.type !== 11 && slide.imageAuthority.type !== 12;
    }
    /**
     * @return {?}
     */
    get showthumbnailBar() {
        return this.photoSwiper && this.photoSwiper.options.thumbnailBar;
    }
    /**
     * 開啟相簿瀏覽器
     * @param {?} openIndex
     * @param {?} slides
     * @param {?} galleryEl
     * @param {?=} options
     * @return {?}
     */
    open(openIndex, slides, galleryEl, options) {
        // 相簿瀏覽器 dom
        /** @type {?} */
        const pswpElement = (/** @type {?} */ (document.querySelectorAll('.pswp')[0]));
        // 剖析出相片物件陣列
        this.parseThumbnailElements(slides, galleryEl);
        this.data = slides;
        // 更新選項
        // TODO: 加入如果是html 的狀況 https://photoswipe.com/documentation/custom-html-in-slides.html
        options = Object.assign({
            tapToToggleControls: false,
            closeOnScroll: false,
            // define gallery index (for URL)
            // galleryUID: galleryEl.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: (/**
             * @param {?} index
             * @return {?}
             */
            (index) => {
                // See Options -> getThumbBoundsFn section of documentation for more info
                /** @type {?} */
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                if (((/** @type {?} */ (slides[index]))).src) {
                    /** @type {?} */
                    const slide = (/** @type {?} */ (slides[index]));
                    /** @type {?} */
                    const thumbnail = slide.el.getElementsByTagName('img')[0];
                    // find thumbnail
                    /** @type {?} */
                    const rect = thumbnail.getBoundingClientRect();
                    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                }
            }),
            addCaptionHTMLFn: (/**
             * @param {?} item
             * @param {?} captionEl
             * @param {?} isFake
             * @return {?}
             */
            (item, captionEl, isFake) => {
                /** @type {?} */
                let authHtml = '';
                if (item.imageAuthorityImg) {
                    authHtml = `<a href="${item.imageAuthorityUrl}" target="_blank" class="copyright-link" title="${item.imageAuthorityText}[另開新視窗]">
            <img src="${item.imageAuthorityImg}" alt="${item.imageAuthorityText}" style="height:20px;width:auto;">
          </a>`;
                }
                else if (item.imageAuthorityUrl) {
                    authHtml = `<a href="${item.imageAuthorityUrl}" target="_blank" class="copyright-link" title="${item.imageAuthorityText}[另開新視窗]">
            ${item.imageAuthorityText}
          </a>`;
                }
                else if (item.imageAuthorityText) {
                    authHtml = item.imageAuthorityText;
                }
                captionEl.children[0].innerHTML = `<div class="caption_tile">${item.title}</div>`
                    + (item.desc === undefined ? '' : `<span class="caption">${item.desc}</span>`)
                    + (item.imageAuthMan && authHtml ? `<p>授權者：${item.imageAuthMan}&nbsp;&nbsp;&nbsp;${authHtml}</p>` : '')
                    + (item.imageAuthMan && !authHtml ? `<p>授權者：${item.imageAuthMan}</p>` : '')
                    + (!item.imageAuthMan && authHtml ? `<p>${authHtml}</p>` : '');
                return true;
            })
        }, options);
        options.index = parseInt(openIndex, 10);
        // 初始化相簿瀏覽器
        this.photoSwiper = new PhotoSwipe(pswpElement, PhotoSwipeUI_TM, slides, options);
        this.photoSwiper.init();
        pswpElement.focus();
        this.isOpened = true;
        this.startObserveDomChange(this.photoSwiper.currItem.container);
        this.indexChanged$.next(options.index);
        this.photoSwiper.listen('close', (/**
         * @return {?}
         */
        () => {
            this.isOpened = false;
            this.cancelObserveDomChange();
            this.clearDownloadBoxData();
        }));
        this.photoSwiper.listen('beforeChange', (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const item = this.photoSwiper.currItem;
            this.indexChanged$.next(this.photoSwiper.getCurrentIndex());
            if (item.container) {
                /** @type {?} */
                const c = ((/** @type {?} */ (item.container))).children;
                // tslint:disable-next-line: prefer-for-of
                for (let i = 0; i < c.length; i++) {
                    if (!c[i].classList.contains('pswp__img:not(.pswp__img--placeholder)')) {
                        return;
                    }
                    c[i].setAttribute('alt', item.alt);
                }
            }
        }));
        this.photoSwiper.listen('preventDragEvent', (/**
         * @param {?} e
         * @param {?} isDown
         * @param {?} preventObj
         * @return {?}
         */
        (e, isDown, preventObj) => {
            // e - original event
            // isDown - true = drag start, false = drag release
            // Line below will force e.preventDefault() on:
            // touchstart/mousedown/pointerdown events
            // as well as on:
            // touchend/mouseup/pointerup events
            preventObj.prevent = false;
        }));
        this.photoSwiper.listen('pointerDown', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            if (!!find(pswpElement.querySelector('.pswp__bottom-bar'), e.target)) {
                // to stop slide
                throw new Error('');
            }
        }));
        this.photoSwiper.listen('downloadModalOpen', (/**
         * @return {?}
         */
        () => {
            this.setDownloadBoxData();
        }));
        this.photoSwiper.listen('downloadModalClose', (/**
         * @return {?}
         */
        () => {
            this.clearDownloadBoxData();
        }));
        document.body.addEventListener('focusin', this.handleFocusInEventHandler);
    }
    /**
     * @param {?} index
     * @return {?}
     */
    viewIn(index) {
        if (!this.photoSwiper) {
            console.error('code error: call open first');
            return;
        }
        this.photoSwiper.goTo(index);
    }
    /**
     * 關閉相簿瀏覽器
     * @return {?}
     */
    close() {
        this.photoSwiper.close();
        this.photoSwiper = undefined;
        this.isOpened = false;
        document.body.removeEventListener('focusin', this.handleFocusInEventHandler);
    }
    /**
     * 打開圖片下載提示窗
     * @protected
     * @return {?}
     */
    setDownloadBoxData() {
        /** @type {?} */
        const currentItem = (/** @type {?} */ (this.currentItem));
        this.downloadData = currentItem;
    }
    /**
     * 關閉圖片下載提示窗
     * @protected
     * @return {?}
     */
    clearDownloadBoxData() {
        this.downloadData = undefined;
    }
    /**
     * 檢查子節點是否改變
     * @protected
     * @param {?} observeDom
     * @return {?}
     */
    startObserveDomChange(observeDom) {
        this.changes.observe(observeDom, {
            childList: true,
        });
    }
    /**
     * 取消檢查子節點是否改變
     * @protected
     * @return {?}
     */
    cancelObserveDomChange() {
        this.changes.disconnect();
    }
    /**
     * 檢查圖片是否已經載入，載入好就改變他的 alt 成圖案名稱
     * @protected
     * @return {?}
     */
    checkIsImgLoaded() {
        if (this.photoSwiper.currItem.imageAppended) {
            /** @type {?} */
            const child = ((/** @type {?} */ (this.photoSwiper.currItem.container))).querySelector('img.pswp__img:not(.pswp__img--placeholder)');
            if (child) {
                child.setAttribute('alt', this.photoSwiper.currItem.alt);
                return;
            }
        }
        this.startObserveDomChange(this.photoSwiper.currItem.container);
    }
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    /**
     * @protected
     * @param {?} slides
     * @param {?} galleryEl
     * @return {?}
     */
    parseThumbnailElements(slides, galleryEl) {
        /** @type {?} */
        const thumbElements = galleryEl.childNodes;
        /** @type {?} */
        let figureEl;
        /** @type {?} */
        let img;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0, slideIndex = 0; i < thumbElements.length; i++) {
            if (((/** @type {?} */ (thumbElements[i]))).children) {
                figureEl = (/** @type {?} */ (((/** @type {?} */ (thumbElements[i]))).children[0])); // <figure> element
            }
            else {
                figureEl = (/** @type {?} */ (thumbElements[i]));
            }
            // include only element nodes
            if (figureEl.nodeType !== 1) {
                continue;
            }
            img = figureEl.querySelector('img[hidden]'); // getAttribute('data-size').split('x');
            // getAttribute('data-size').split('x');
            /** @type {?} */
            const currentItem = slides[slideIndex];
            // create slide object
            Object.assign(currentItem, {
                w: img.width,
                h: img.height,
                el: figureEl,
                // save link to element for getThumbBoundsFn
                fileExt: currentItem.src.substr(currentItem.src.lastIndexOf('.') + 1, currentItem.src.length).toUpperCase(),
            });
            if (currentItem.imageAuthority) {
                /** @type {?} */
                const type1Option = TYPE1_OPTIONS.find((/**
                 * @param {?} item
                 * @return {?}
                 */
                item => item.value === currentItem.imageAuthority.type));
                if (type1Option) {
                    currentItem.imageAuthorityText = type1Option.label;
                    currentItem.imageAuthorityImg = type1Option.image;
                    currentItem.imageAuthorityUrl = type1Option.url;
                }
            }
            else {
                currentItem.imageAuthorityText = '';
            }
            if (!currentItem.originUrl) {
                currentItem.originUrl = window.location.href;
            }
            slideIndex++;
        }
    }
}
PhotoSwipeService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
PhotoSwipeService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
if (false) {
    /**
     * 圖片資料
     * @type {?}
     */
    PhotoSwipeService.prototype.data$;
    /**
     * PhotoSwipe 實例
     * @type {?}
     * @protected
     */
    PhotoSwipeService.prototype.photoSwiper;
    /**
     * 相簿瀏覽器是否開啟中
     * @type {?}
     */
    PhotoSwipeService.prototype.isOpened$;
    /**
     * 檢查圖片是否載入用
     * @type {?}
     * @protected
     */
    PhotoSwipeService.prototype.changes;
    /**
     * 當前瀏覽Slide的指標改變
     * @type {?}
     */
    PhotoSwipeService.prototype.indexChanged$;
    /**
     * 圖片下載資料
     * @type {?}
     */
    PhotoSwipeService.prototype.downloadData$;
    /** @type {?} */
    PhotoSwipeService.prototype.isTouchDevice;
    /**
     * 查看當前焦點是否在相簿瀏覽器內，若不在就關閉相簿瀏覽器
     * @type {?}
     * @protected
     */
    PhotoSwipeService.prototype.handleFocusInEventHandler;
    /**
     * @type {?}
     * @private
     */
    PhotoSwipeService.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/photo-swipe/photo-swipe.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import * as Hammer from 'hammerjs';
/**
 * 可手勢滑動的相簿瀏覽器模板
 * 在文檔中只要放一個
 */
class PhotoSwipeComponent {
    /**
     * @param {?} photoSwipeService
     */
    constructor(photoSwipeService) {
        this.photoSwipeService = photoSwipeService;
        this.currentIndex = 0;
        this.showthumbnailBar = true;
        this.isThumbnailOpened = true;
        this.isOpened = false;
        /**
         * 下載區塊複製授權的文字轉換
         */
        this.downloadRightsCitationFormatter = (/**
         * @return {?}
         */
        () => {
            if (this.downloadData) {
                return `${this.downloadData.title ? this.downloadData.title + '。' : ''}${this.downloadData.imageAuthMan ? '授權人：' + this.downloadData.imageAuthMan + '。' : ''}${this.downloadData.imageAuthorityText ? this.downloadData.imageAuthorityText + '。' : ''}來源：${this.downloadData.originUrl}。`;
            }
            else {
                return undefined;
            }
        });
        // protected hammerMc: any;
        this.thumbScrollDistance = 0;
        this.hasThumbAnimated = false;
        this.mdThumbnailHandler = (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            /** @type {?} */
            const mouseUp = fromEvent(document, 'mouseup');
            /** @type {?} */
            const mouseMove = fromEvent(document, 'mousemove');
            /** @type {?} */
            const origOffset = this.thumbScrollDistance;
            this.thunbMovingSubc = mouseMove.pipe(takeUntil(mouseUp), debounceTime(10), map((/**
             * @param {?} move
             * @return {?}
             */
            move => {
                /** @type {?} */
                let nd = origOffset - (move.clientX - e.clientX);
                if (nd > (this.thumbTotalWidth - this.thumbOuterWidth)) {
                    nd = this.thumbTotalWidth - this.thumbOuterWidth;
                }
                if (nd < 0) {
                    nd = 0;
                }
                // console.log(`d: ${e.clientX}, m: ${move.clientX}, odis: ${this.thumbScrollDistance}, origOffset: ${origOffset}, nd: ${nd}`)
                return nd;
            }))).subscribe((/**
             * @param {?} offset
             * @return {?}
             */
            offset => {
                this.thumbScrollDistance = offset;
                this.thumb.nativeElement.setAttribute('style', `transform: translate3d(-${offset}px, 0px, 0px)`);
            }));
        });
    }
    /**
     * @return {?}
     */
    get isCurrentFigureSlide() {
        return this.photoSwipeService.isCurrentFigureSlide;
    }
    /**
     * @return {?}
     */
    get canDownload() {
        return this.photoSwipeService.canDownload;
    }
    /**
     * @return {?}
     */
    get thumbTotalWidth() { return this.thumb ? getElementStyleSize(this.thumb.nativeElement).w : 0; }
    /**
     * @return {?}
     */
    get thumbOuterWidth() { return this.thumbOuter ? getElementStyleSize(this.thumbOuter.nativeElement).w : 0; }
    /**
     * @return {?}
     */
    get isTouchDevice() { return this.photoSwipeService.isTouchDevice; }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.photoSwipeService.data$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.data = data;
        }));
        this.photoSwipeService.isOpened$.pipe(skip(1)).subscribe((/**
         * @param {?} isOpened
         * @return {?}
         */
        isOpened => {
            this.isOpened = isOpened;
            this.showthumbnailBar = this.photoSwipeService.showthumbnailBar;
            this.isThumbnailOpened = this.photoSwipeService.showthumbnailBar;
            if (this.showthumbnailBar) {
                this.initThumbnailSwipe();
            }
        }));
        this.photoSwipeService.indexChanged$.subscribe((/**
         * @param {?} index
         * @return {?}
         */
        index => {
            if (typeof index === 'number') {
                this.currentIndex = index;
                if (this.showthumbnailBar) {
                    if (!this.hasThumbAnimated) {
                        this.animateThumb(index);
                    }
                    else {
                        this.hasThumbAnimated = false;
                    }
                }
            }
        }));
        this.photoSwipeService.downloadData$.subscribe((/**
         * @param {?} dData
         * @return {?}
         */
        dData => {
            this.downloadData = dData;
            this.downloadRightsCitation = this.downloadRightsCitationFormatter(dData);
        }));
    }
    /**
     * 切換是否顯示下方縮圖列
     * @return {?}
     */
    toggleThumbnail() {
        this.isThumbnailOpened = !this.isThumbnailOpened;
        if (!this.isTouchDevice) {
            this.initThumbnailSwipe();
        }
    }
    // 用 hammerjs 的版本
    // initThumbnailSwipe() {
    //   if (this.isThumbnailOpened) {
    //     const scrollEl = document.querySelector('.pswp__thumb-scroller');
    //     if (!this.hammerMc) {
    //       this.hammerMc = new Hammer.Manager(scrollEl);
    //       this.hammerMc.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL, threshold: 0 }));
    //     }
    //     this.hammerMc.on('swipe', this.swipeThumbnailHandler);
    //   } else if (this.hammerMc) {
    //     this.hammerMc.off('swipe', this.swipeThumbnailHandler);
    //   }
    // }
    // swipeThumbnailHandler = (ev) => {
    //   console.log(ev);
    //   let nd = this.thumbScrollDistance - ev.deltaX;
    //   if (nd > (this.thumbTotalWidth - this.thumbOuterWidth)) { nd = this.thumbTotalWidth - this.thumbOuterWidth; }
    //   if (nd < 0) { nd = 0; }
    //   this.thumbScrollDistance = nd;
    //   this.thumb.nativeElement.setAttribute('style', `transform: translate3d(-${this.thumbScrollDistance}px, 0px, 0px)`);
    // }
    /**
     * @return {?}
     */
    initThumbnailSwipe() {
        /** @type {?} */
        const scrollEl = document.querySelector('.pswp__thumb-scroller');
        if (this.isThumbnailOpened && !this.thunbMovingSubc) {
            scrollEl.addEventListener('mousedown', this.mdThumbnailHandler);
        }
        else if (this.thunbMovingSubc) {
            this.thunbMovingSubc.unsubscribe();
            this.thunbMovingSubc = undefined;
            scrollEl.removeEventListener('mousedown', this.mdThumbnailHandler);
        }
    }
    /**
     * @param {?} index
     * @param {?} e
     * @return {?}
     */
    viewIn(index, e) {
        this.photoSwipeService.viewIn(index);
        this.animateThumb(index);
        this.hasThumbAnimated = true;
    }
    /**
     * @return {?}
     */
    copyCitation() {
        /** @type {?} */
        const el = document.getElementById('tm_pswp-rights-citation');
        if (((/** @type {?} */ (document.body))).createTextRange) { // IE
            // IE
            /** @type {?} */
            const range = ((/** @type {?} */ (document.body))).createTextRange();
            range.moveToElementText(el);
            range.select();
            document.execCommand('Copy');
        }
        else if (window.getSelection) {
            // other browsers
            /** @type {?} */
            const range = document.createRange();
            // range.selectNodeContents(elemID);
            range.selectNode(el);
            /** @type {?} */
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    animateThumb(index) {
        /** @type {?} */
        const thumbnailWidth = 100;
        /** @type {?} */
        const thumbnailMargin = 5;
        /** @type {?} */
        let position;
        position = (this.thumbOuterWidth / 2) - (thumbnailWidth / 2);
        this.thumbScrollDistance = ((thumbnailWidth + thumbnailMargin) * index - 1) - position;
        if (this.thumbScrollDistance > (this.thumbTotalWidth - this.thumbOuterWidth)) {
            this.thumbScrollDistance = this.thumbTotalWidth - this.thumbOuterWidth;
        }
        if (this.thumbScrollDistance < 0) {
            this.thumbScrollDistance = 0;
        }
        this.thumb.nativeElement.setAttribute('style', `transform: translate3d(-${this.thumbScrollDistance}px, 0px, 0px)`);
    }
}
PhotoSwipeComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-photo-swipe',
                template: "\r\n<!-- Root element of PhotoSwipe. Must have class pswp. -->\r\n<div class=\"pswp\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" attr.aria-roledescription=\"\u76F8\u7247\u6AA2\u8996\u5668(\u6309 ESC \u96E2\u958B)\">\r\n  <!-- Background of PhotoSwipe.\r\n        It's a separate element as animating opacity is faster than rgba(). -->\r\n  <div class=\"pswp__bg\"></div>\r\n\r\n  <!-- Slides wrapper with overflow:hidden. -->\r\n  <div class=\"pswp__scroll-wrap\">\r\n    <!-- Container that holds slides.\r\n        PhotoSwipe keeps only 3 of them in the DOM to save memory.\r\n        Don't modify these 3 pswp__item elements, data is added later on. -->\r\n    <div class=\"pswp__container\">\r\n      <div class=\"pswp__item\"></div>\r\n      <div class=\"pswp__item\"></div>\r\n      <div class=\"pswp__item\"></div>\r\n    </div>\r\n    <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->\r\n    <div class=\"pswp__ui pswp__ui--hidden\">\r\n      <div class=\"pswp__top-bar\">\r\n        <!--  Controls are self-explanatory. Order can be changed. -->\r\n        <div class=\"pswp__counter\"></div>\r\n        <button class=\"pswp__button pswp__button--zoom\" title=\"\u7E2E\u5C0F/\u653E\u5927\"><span class=\"sr-only\">\u7E2E\u5C0F/\u653E\u5927</span></button>\r\n        <button class=\"pswp__button pswp__button--fs\" title=\"\u5207\u63DB\u5168\u87A2\u5E55\"><span class=\"sr-only\">\u5207\u63DB\u5168\u87A2\u5E55</span></button>\r\n        <button class=\"pswp__button pswp__button--download\" title=\"\u4E0B\u8F09\">\r\n          <i class=\"fa fa-download\" aria-hidden=\"true\" style=\"pointer-events: none;\"></i><span class=\"sr-only\">\u4E0B\u8F09</span>\r\n        </button>\r\n        <button class=\"pswp__button pswp__button--share\" title=\"\u5206\u4EAB\"><span class=\"sr-only\">\u5206\u4EAB</span></button>\r\n        <button class=\"pswp__button pswp__button--close\" title=\"\u95DC\u9589(ESC)\"><span class=\"sr-only\">\u95DC\u9589(ESC)</span></button>\r\n        <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->\r\n        <!-- element will get class pswp__preloader--active when preloader is running -->\r\n        <div class=\"pswp__preloader\">\r\n          <div class=\"pswp__preloader__icn\">\r\n            <div class=\"pswp__preloader__cut\">\r\n              <div class=\"pswp__preloader__donut\"></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"pswp__share-modal pswp__share-modal--hidden pswp__single-tap\">\r\n        <div class=\"pswp__share-tooltip\"></div>\r\n      </div>\r\n\r\n      <div class=\"pswp__download-modal pswp__download-modal--hidden pswp__single-tap\">\r\n        <div class=\"pswp__download-tooltip\">\r\n          <ng-container *ngIf=\"downloadData\">\r\n            <ng-container *ngTemplateOutlet=\"downloadToolTipTmp ? downloadToolTipTmp : downloadToolTipDefaultTmp; context: {$implicit: downloadData}\"></ng-container>\r\n            <ng-template #downloadToolTipDefaultTmp let-downloadData>\r\n              <div *ngIf=\"canDownload\" class=\"tm_pswp-download\">\r\n                <a class=\"download-btn btn\" title=\"{{ downloadData.title }}[\u53E6\u958B\u65B0\u8996\u7A97]\" target=\"_blank\" href=\"{{ downloadData.src }}\">\r\n                  <span class=\"label\">\u4E0B\u8F09\u6A94\u6848</span>\r\n                  <span class=\"format\"><div>{{ downloadData.w }} x {{ downloadData.h }} \u50CF\u7D20 {{ downloadData.fileExt }}</div></span>\r\n                </a>\r\n              </div>\r\n              <div class=\"tm_pswp-info\">\r\n                <div class=\"tm_pswp-usage-info\">\r\n                  <!-- \u7248\u6B0A\u63D0\u793A  -->\r\n                  <div *ngIf=\"downloadData.imageAuthorityImg || !downloadData.imageAuthorityUrl\" class=\"tm_pswp-rights-tip\">{{ downloadData.imageAuthMan ? '\u6388\u6B0A\u4EBA\uFF1A' + downloadData.imageAuthMan : '' }}<br>\r\n                    {{ downloadData.imageAuthorityText }}\r\n                    <!-- ICON  -->\r\n                    <a *ngIf=\"downloadData.imageAuthorityImg\" href=\"{{ downloadData.imageAuthorityUrl }}\" target=\"_blank\" class=\"tm_pswp-copyright copyright-link\" title=\"{{ downloadData.imageAuthorityText }}[\u53E6\u958B\u65B0\u8996\u7A97]\">\r\n                      <img src=\"{{ downloadData.imageAuthorityImg }}\" alt=\"{{ downloadData.imageAuthorityText }}\">\r\n                    </a>\r\n                  </div>\r\n                  <div *ngIf=\"!downloadData.imageAuthorityImg && downloadData.imageAuthorityUrl\" class=\"tm_pswp-rights-tip\">{{ downloadData.imageAuthMan ? '\u6388\u6B0A\u4EBA\uFF1A' + downloadData.imageAuthMan : '' }}<br>\r\n                    <a href=\"{{ downloadData.imageAuthorityUrl }}\" target=\"_blank\" class=\"copyright-link\" title=\"{{ downloadData.imageAuthorityText }}[\u53E6\u958B\u65B0\u8996\u7A97]\">\r\n                      {{ downloadData.imageAuthorityText }}\r\n                    </a>\r\n                  </div>\r\n                  <div *ngIf=\"canDownload\" class=\"tm_pswp-cite-tip\" (click)=\"copyCitation()\"><i class=\"fa fa-clone\" aria-hidden=\"true\"></i>&nbsp;\u8907\u88FD</div>\r\n                  <!-- \u5F15\u7528\u6587\u5B57  -->\r\n                  <div *ngIf=\"canDownload\" class=\"tm_pswp-rights-citation\" id=\"tm_pswp-rights-citation\">{{downloadRightsCitation}}</div>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n\r\n      <button class=\"pswp__button pswp__button--arrow--left\" title=\"\u4E0A\u4E00\u5F35 (\u5DE6\u7BAD\u982D)\"><span class=\"sr-only\">\u4E0A\u4E00\u5F35 (\u5DE6\u7BAD\u982D)</span></button>\r\n      <button class=\"pswp__button pswp__button--arrow--right\" title=\"\u4E0B\u4E00\u5F35 (\u53F3\u7BAD\u982D)\"><span class=\"sr-only\">\u4E0B\u4E00\u5F35 (\u53F3\u7BAD\u982D)</span></button>\r\n\r\n      <div class=\"pswp__caption\" [class.pswp__thumb-viewing]=\"isThumbnailOpened\">\r\n        <div class=\"pswp__caption__center\"></div>\r\n      </div>\r\n\r\n      <div class=\"pswp__bottom-bar\" [class.pswp__bottom-bar-open]=\"isOpened\" *ngIf=\"showthumbnailBar\">\r\n        <div class=\"pswp__thumb-outer\" #thumbOuter [class.pswp__thumb-viewing]=\"isThumbnailOpened\">\r\n          <div class=\"pswp__thumb-scroller\" [class.pswp__thumb-scroller-touch-device]=\"isTouchDevice\">\r\n            <div class=\"pswp__thumb clearfix\" #thumb>\r\n              <ng-container *ngFor=\"let item of data; index as i\">\r\n                <div *ngIf=\"$any(item).src\" class=\"pswp__thumb-item\" [class.active]=\"currentIndex === i\" (click)=\"viewIn(i, $event)\">\r\n                  <img src=\"{{ $any(item).msrc }}\" alt=\"{{$any(item).alt}}\">\r\n                </div>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <button class=\"pswp__toogle-thumb pswp__icon\" title=\"\u986F\u793A/\u96B1\u85CF\u5C0F\u5716\" (click)=\"toggleThumbnail()\">\r\n            <i class=\"fa fa-th\" aria-hidden=\"true\"></i><span class=\"sr-only\">\u986F\u793A/\u96B1\u85CF\u5C0F\u5716</span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .pswp__share--download{display:none}:host ::ng-deep .pswp__button--download{background-image:none!important}:host ::ng-deep .pswp__button--download i.fa-download{color:#fff;font-size:1.8rem;line-height:44px}:host ::ng-deep img[class].pswp__img{max-width:none}.pswp__bottom-bar{opacity:0}.pswp__bottom-bar-open{opacity:1}.pswp__thumb-outer{background-color:#0d0a0a;bottom:0;position:absolute;width:100%;height:120px;z-index:1080;max-height:350px;transform:translate3d(0,100%,0);transition:transform .25s cubic-bezier(0,0,.25,1)}.pswp__caption{transition:transform .25s cubic-bezier(0,0,.25,1)}.pswp__caption .caption{white-space:pre-wrap;word-break:break-all;overflow:hidden}.pswp__thumb-viewing.pswp__caption{transform:translate3d(0,-120px,0)}.pswp__thumb-viewing.pswp__thumb-outer{transform:translate3d(0,0,0)}.pswp__thumb-scroller{overflow-x:scroll;width:100%;height:137px}.pswp__thumb-scroller-touch-device{height:120px;-webkit-overflow-scrolling:touch}.pswp__thumb-scroller:active .pswp__thumb-item{cursor:-webkit-grabbing;cursor:grabbing}.pswp__thumb{padding:10px 0;height:100%;margin-bottom:-5px;position:relative;transition-duration:.6s;width:-webkit-max-content;width:-moz-max-content;width:max-content}.pswp__thumb-item{border-radius:4px;cursor:pointer;float:left;overflow:hidden;border:2px solid #fff;margin-bottom:5px;width:100px;height:100%}.pswp__thumb-item:not(:last-child){margin-right:5px}@media screen and (min-width:1025px){.pswp__thumb-item{transition:border-color .25s}}.pswp__thumb-item.active,.pswp__thumb-item:hover{border-color:#a90707}.pswp__thumb-item img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.pswp__toogle-thumb{background-color:#0d0a0a;border-radius:2px 2px 0 0;color:#999;cursor:pointer;font-size:2.4rem;height:39px;line-height:27px;padding:5px 0;position:absolute;right:20px;text-align:center;top:-39px;width:50px;outline:0;border:none}.pswp__caption__center{text-align:center;max-width:500px}@media screen and (max-width:619px){.pswp__caption__center{padding:10px 70px 10px 10px}}.pswp__top-bar{text-align:right}.pswp__top-bar .pswp__button{float:none;display:inline-block;vertical-align:top}"]
            }] }
];
/** @nocollapse */
PhotoSwipeComponent.ctorParameters = () => [
    { type: PhotoSwipeService }
];
PhotoSwipeComponent.propDecorators = {
    downloadRightsCitationFormatter: [{ type: Input }],
    downloadToolTipTmp: [{ type: Input }],
    thumbOuter: [{ type: ViewChild, args: ['thumbOuter', { static: false },] }],
    thumb: [{ type: ViewChild, args: ['thumb', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PhotoSwipeComponent.prototype.data;
    /** @type {?} */
    PhotoSwipeComponent.prototype.currentIndex;
    /** @type {?} */
    PhotoSwipeComponent.prototype.showthumbnailBar;
    /** @type {?} */
    PhotoSwipeComponent.prototype.isThumbnailOpened;
    /** @type {?} */
    PhotoSwipeComponent.prototype.isOpened;
    /** @type {?} */
    PhotoSwipeComponent.prototype.downloadData;
    /**
     * 下載區塊複製授權的文字轉換
     * @type {?}
     */
    PhotoSwipeComponent.prototype.downloadRightsCitationFormatter;
    /**
     * 下載區塊複製授權的文字
     * @type {?}
     */
    PhotoSwipeComponent.prototype.downloadRightsCitation;
    /**
     * 下載提示窗口模版，若未設定則採用預設的版型，自訂模板須接受一個隱式的參數
     * @type {?}
     */
    PhotoSwipeComponent.prototype.downloadToolTipTmp;
    /** @type {?} */
    PhotoSwipeComponent.prototype.thumbOuter;
    /** @type {?} */
    PhotoSwipeComponent.prototype.thumb;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeComponent.prototype.thumbScrollDistance;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeComponent.prototype.thunbMovingSubc;
    /** @type {?} */
    PhotoSwipeComponent.prototype.hasThumbAnimated;
    /** @type {?} */
    PhotoSwipeComponent.prototype.mdThumbnailHandler;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeComponent.prototype.photoSwipeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/photo-swipe.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 可手勢滑動的相簿瀏覽器
 * https://photoswipe.com/documentation/getting-started.html
 * 原名: appPhotoSwip
 */
class PhotoSwipeDirective {
    /**
     * @param {?} platformId
     * @param {?} el
     * @param {?} photoSwipeService
     * @param {?} render
     */
    constructor(platformId, el, photoSwipeService, render) {
        this.platformId = platformId;
        this.el = el;
        this.photoSwipeService = photoSwipeService;
        this.render = render;
        /**
         * 可以開始使用元件了
         */
        this.canInit = false;
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) {
            if (!PhotoSwipeDirective.isPluginInit && !PhotoSwipeDirective.isPluginIniting) {
                if (isPluginLoaded()) {
                    PhotoSwipeDirective.isPluginInit = true;
                }
                else {
                    PhotoSwipeDirective.loadPlugin(this.render, this.el.nativeElement, this.isBrowser);
                    this.slideListEl = this.el.nativeElement;
                }
            }
        }
    }
    /**
     * 載入插件的方法
     * @param {?} renderer
     * @param {?} parentEl
     * @param {?} isBrowser
     * @return {?}
     */
    static loadPlugin(renderer, parentEl, isBrowser) {
        PhotoSwipeDirective.isPluginIniting = true;
        loadLazyCssFile(renderer, parentEl, 'photoswipeBundleStyle', 'photoswipeStyle.bundle.css', !isBrowser);
        loadLazyJsFile(renderer, 'photoswipe.bundle.js');
        checkPluginCanUse((/**
         * @return {?}
         */
        () => {
            PhotoSwipeDirective.isPluginInit = true;
            PhotoSwipeDirective.isPluginIniting = false;
            PhotoSwipeDirective.pulginInit.emit();
            PhotoSwipeDirective.pulginInit.complete();
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (!PhotoSwipeDirective.isPluginInit) {
                PhotoSwipeDirective.pulginInit.subscribe((/**
                 * @return {?}
                 */
                () => {
                    this.canInit = true;
                }));
            }
            else {
                this.canInit = true;
            }
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if ('slideListEl' in changes) {
            this.slideListEl = changes['slideListEl'].currentValue;
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    onThumbnailsClick(evt) {
        evt = evt || window.event;
        evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
        if (!this.canInit) {
            alert('相簿檢視器插件尚未完全載入，請稍後再試');
            return;
        }
        /** @type {?} */
        const eTarget = evt.target || evt.srcElement;
        /** @type {?} */
        let selectedIdx;
        /** @type {?} */
        const clickedListItem = this.closest(eTarget, (/**
         * @param {?} el
         * @return {?}
         */
        (el) => {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        }));
        if (!clickedListItem) {
            return;
        }
        selectedIdx = clickedListItem.dataset.item;
        if (selectedIdx >= 0) {
            this.photoSwipeService.open(selectedIdx, this.potoswipeSlides, this.slideListEl, this.potoswipeOptions);
        }
    }
    /**
     * @return {?}
     */
    close() {
        this.photoSwipeService.close();
    }
    /**
     * @protected
     * @param {?} el
     * @param {?} fn
     * @return {?}
     */
    closest(el, fn) {
        return el && (fn(el) ? el : this.closest(el.parentNode, fn));
    }
}
/**
 * photoswipe 插件初始化完成後觸發
 */
PhotoSwipeDirective.pulginInit = new EventEmitter();
/**
 * 全域的 photoswipe 插件初始化完成
 */
PhotoSwipeDirective.isPluginInit = false;
/**
 * 全域的 photoswipe 插件在正初始化中
 */
PhotoSwipeDirective.isPluginIniting = false;
PhotoSwipeDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmPhotoSwipe]'
            },] }
];
/** @nocollapse */
PhotoSwipeDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: PhotoSwipeService },
    { type: Renderer2 }
];
PhotoSwipeDirective.propDecorators = {
    potoswipeOptions: [{ type: Input, args: ['tmPhotoSwipe',] }],
    potoswipeSlides: [{ type: Input }],
    slideListEl: [{ type: Input }],
    onThumbnailsClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
if (false) {
    /**
     * photoswipe 插件初始化完成後觸發
     * @type {?}
     */
    PhotoSwipeDirective.pulginInit;
    /**
     * 全域的 photoswipe 插件初始化完成
     * @type {?}
     */
    PhotoSwipeDirective.isPluginInit;
    /**
     * 全域的 photoswipe 插件在正初始化中
     * @type {?}
     */
    PhotoSwipeDirective.isPluginIniting;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    PhotoSwipeDirective.prototype.isBrowser;
    /**
     * 可以開始使用元件了
     * @type {?}
     */
    PhotoSwipeDirective.prototype.canInit;
    /** @type {?} */
    PhotoSwipeDirective.prototype.potoswipeOptions;
    /** @type {?} */
    PhotoSwipeDirective.prototype.potoswipeSlides;
    /**
     * 用來剖析出相片物件陣列的元素，預設是宿主元素
     * @type {?}
     */
    PhotoSwipeDirective.prototype.slideListEl;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeDirective.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeDirective.prototype.photoSwipeService;
    /**
     * @type {?}
     * @protected
     */
    PhotoSwipeDirective.prototype.render;
}
/**
 * @return {?}
 */
function isPluginLoaded() {
    return ((/** @type {?} */ (window))).PhotoSwipe;
}
/** @type {?} */
const checkPluginCanUse = (/**
 * @param {?} cb
 * @return {?}
 */
(cb) => {
    /** @type {?} */
    const cpTmSubc = timer(0, 300).subscribe((/**
     * @param {?} t
     * @return {?}
     */
    t => {
        if (isPluginLoaded()) {
            cpTmSubc.unsubscribe();
            cb();
        }
    }));
});
const ɵ0 = checkPluginCanUse;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/photo-swipe.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhotoSwipeModule {
    constructor() {
        closestPolifill();
    }
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: PhotoSwipeModule,
            providers: [PhotoSwipeService]
        };
    }
}
PhotoSwipeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PhotoSwipeComponent,
                    PhotoSwipeDirective
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    PhotoSwipeComponent,
                    PhotoSwipeDirective
                ]
            },] }
];
/** @nocollapse */
PhotoSwipeModule.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-photo-swipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PhotoSwipeComponent, PhotoSwipeDirective, PhotoSwipeModule, PhotoSwipeService, checkIsTouchMobile, closestPolifill, find, getElementStyleSize, getPixelValue, loadLazyCssFile, loadLazyJsFile, roundDecimal };
//# sourceMappingURL=techmore-photo-swipe.js.map
